import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { SearchComponent } from '../search/search.component';
import { MiraLogoComponent } from '../ui/mira-logo/mira-logo.component';
import { ThemeToggleComponent } from '../ui/theme-toggle/theme-toggle.component';

@Component({
    selector: 'app-navbar',
    imports: [
        RouterLink,
        SearchComponent,
        MiraLogoComponent,
        ThemeToggleComponent
    ],
    templateUrl: './navbar.component.html',
    styleUrl: './navbar.component.less',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class NavbarComponent {

}
